module.exports = __webpack_public_path__ + "img/three3Blue.90ccbd95.jpg";